// Cart Upsells Carousel - Custom Element
if (!customElements.get('cart-upsells-carousel')) {
  customElements.define('cart-upsells-carousel', class extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
    }
    
    connectedCallback() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.init();
        });
      });
    }
    
    init() {
      if (this.initialized) return;
      
      const slides = this.querySelectorAll('.cart-upsells-slide');
      this.slides = Array.from(slides);
      this.dataset.count = this.slides.length;
      
      if (this.slides[0]) this.slides[0].style.display = 'block';
      
      if (this.slides.length <= 1) {
        this.initialized = true;
        return;
      }
      
      this.slides.forEach((slide, i) => {
        slide.style.display = i === 0 ? 'block' : 'none';
      });
      
      this.createNav();
      this.initialized = true;
    }
    
    createNav() {
      const existing = this.querySelector('.cart-upsells-manual-nav');
      if (existing) existing.remove();
      
      const nav = document.createElement('div');
      nav.className = 'cart-upsells-manual-nav';
      nav.innerHTML = `
        <button type="button" class="cart-upsells-nav-btn cart-upsells-nav-prev" aria-label="Previous">
          <svg width="12" height="12" viewBox="0 0 12 12"><path d="M7.5 9L4.5 6L7.5 3" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>
        </button>
        <div class="cart-upsells-nav-dots"></div>
        <button type="button" class="cart-upsells-nav-btn cart-upsells-nav-next" aria-label="Next">
          <svg width="12" height="12" viewBox="0 0 12 12"><path d="M4.5 3L7.5 6L4.5 9" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>
        </button>
      `;
      this.appendChild(nav);
      
      const dotsContainer = nav.querySelector('.cart-upsells-nav-dots');
      this.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cart-upsells-nav-dot' + (i === 0 ? ' is-active' : '');
        dot.onclick = (e) => { e.preventDefault(); e.stopPropagation(); this.goTo(i); };
        dotsContainer.appendChild(dot);
      });
      this.dotsContainer = dotsContainer;
      
      nav.querySelector('.cart-upsells-nav-prev').onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length);
      };
      
      nav.querySelector('.cart-upsells-nav-next').onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.goTo((this.currentIndex + 1) % this.slides.length);
      };
    }
    
    goTo(index) {
      this.slides[this.currentIndex].style.display = 'none';
      this.currentIndex = index;
      this.slides[this.currentIndex].style.display = 'block';
      
      this.dotsContainer.querySelectorAll('.cart-upsells-nav-dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.currentIndex);
      });
    }
  });
}

// Button handlers - use event delegation for dynamically created elements
function initCartUpsellButtons() {
  // Only set up delegation once
  if (window._cartUpsellDelegationSetup) return;
  window._cartUpsellDelegationSetup = true;
  
  // Event delegation on document body for all upsell buttons
  document.body.addEventListener('click', function(e) {
    // Check for inline upsell buttons (new)
    const inlineBtn = e.target.closest('.cart-item-upsell__btn');
    if (inlineBtn) {
      e.preventDefault();
      e.stopPropagation();
      
      if (inlineBtn.classList.contains('cart-item-upsell__btn--variant')) {
        handleInlineVariantClick({ currentTarget: inlineBtn, preventDefault: () => {}, stopPropagation: () => {} });
      } else {
        handleInlineUpsellClick({ currentTarget: inlineBtn, preventDefault: () => {}, stopPropagation: () => {} });
      }
      return;
    }
    
    // Check for old carousel upsell buttons
    const carouselBtn = e.target.closest('.cart-upsell-add-btn');
    if (carouselBtn) {
      e.preventDefault();
      e.stopPropagation();
      
      if (carouselBtn.classList.contains('cart-upsell-variant-btn')) {
        handleVariantClick({ currentTarget: carouselBtn, preventDefault: () => {}, stopPropagation: () => {} });
      } else {
        handleAddClick({ currentTarget: carouselBtn, preventDefault: () => {}, stopPropagation: () => {} });
      }
      return;
    }
  });
  
  console.log('Cart upsell event delegation initialized');
}

// Handle inline upsell add/swap click
async function handleInlineUpsellClick(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const btn = e.currentTarget;
  const variantId = btn.dataset.variantId;
  const isSwap = btn.dataset.isSwap === 'true';
  const originalItemKey = btn.dataset.originalItemKey;
  const originalVariantId = btn.dataset.originalVariantId;
  
  console.log('Upsell click:', { variantId, isSwap, originalItemKey, originalVariantId });
  
  btn.classList.add('loading');
  const label = btn.querySelector('.label');
  const loader = btn.querySelector('.loading-overlay');
  if (label) label.style.visibility = 'hidden';
  if (loader) loader.classList.remove('hidden');
  
  try {
    // Add the upsell product first
    console.log('Adding upsell product:', variantId);
    const props = { 
      '_upsell_type': isSwap ? 'swap' : 'pair'
    };
    
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        items: [{ 
          id: parseInt(variantId), 
          quantity: 1, 
          properties: props 
        }] 
      })
    });
    
    const addResult = await addResponse.json();
    console.log('Add result:', addResult);
    
    if (isSwap && originalItemKey) {
      console.log('Swap mode - removing original item with key:', originalItemKey);
      
      // For swap: Remove original item using line item key
      // The key format is like "41234567890123:abc123" 
      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          id: originalItemKey,
          quantity: 0 
        })
      });
      
      const removeResult = await removeResponse.json();
      console.log('Remove result:', removeResult);
    }
    
    // Dispatch cart refresh event instead of page reload
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    
  } catch(err) {
    console.error('Inline upsell error:', err);
    btn.classList.remove('loading');
    if (label) label.style.visibility = 'visible';
    if (loader) loader.classList.add('hidden');
  }
}

// Handle inline variant click (for products with multiple variants)
async function handleInlineVariantClick(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const btn = e.currentTarget;
  const handle = btn.dataset.productHandle;
  const isSwap = btn.dataset.isSwap === 'true';
  const originalItemKey = btn.dataset.originalItemKey;
  const originalVariantId = btn.dataset.originalVariantId;
  
  try {
    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();
    openInlineVariantModal(product, isSwap, originalItemKey, originalVariantId);
  } catch(err) {
    console.error(err);
  }
}

// Open variant modal for inline upsells
function openInlineVariantModal(product, isSwap, originalItemKey, originalVariantId) {
  const modal = document.getElementById('cart-upsell-variant-modal');
  if (!modal) return;
  
  modal.product = product;
  modal.isSwap = isSwap;
  modal.originalItemKey = originalItemKey;
  modal.originalVariantId = originalVariantId;
  modal.selectedOptions = {};
  
  const productEl = modal.querySelector('.cart-upsell-variant-modal__product');
  const optionsEl = modal.querySelector('.cart-upsell-variant-modal__options');
  
  productEl.innerHTML = `
    <div class="cart-upsell-variant-modal__product-image">
      <img src="${product.featured_image}" alt="${product.title}">
    </div>
    <div class="cart-upsell-variant-modal__product-info">
      <h3 class="cart-upsell-variant-modal__product-title">${product.title}</h3>
      <div class="cart-upsell-variant-modal__product-price">$${(product.price / 100).toFixed(2)}</div>
    </div>
  `;
  
  let html = '';
  product.options.forEach((opt, idx) => {
    const values = [...new Set(product.variants.map(v => v.options[idx]))];
    html += `<div class="cart-upsell-variant-modal__option-group">
      <span class="cart-upsell-variant-modal__option-label">${opt}</span>
      <div class="cart-upsell-variant-modal__swatches">
        ${values.map(v => `<button type="button" class="cart-upsell-variant-modal__swatch" data-idx="${idx}" data-val="${v}">${v}</button>`).join('')}
      </div>
    </div>`;
  });
  optionsEl.innerHTML = html;
  
  optionsEl.querySelectorAll('.cart-upsell-variant-modal__swatch').forEach(s => {
    s.onclick = async () => {
      const idx = parseInt(s.dataset.idx);
      modal.selectedOptions[idx] = s.dataset.val;
      s.closest('.cart-upsell-variant-modal__swatches').querySelectorAll('.cart-upsell-variant-modal__swatch').forEach(x => x.classList.remove('is-selected'));
      s.classList.add('is-selected');
      
      // Check if all options selected for inline modal (auto-add)
      if (Object.keys(modal.selectedOptions).length === product.options.length) {
        const variant = product.variants.find(v => 
          product.options.every((_, i) => v.options[i] === modal.selectedOptions[i])
        );
        
        if (variant && variant.available) {
          s.classList.add('is-selected');
          
          // Auto-add after selection
          try {
            // Add new product first
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ 
                items: [{ 
                  id: variant.id, 
                  quantity: 1, 
                  properties: { '_upsell_type': modal.isSwap ? 'swap' : 'pair' }
                }] 
              })
            });
            
            if (modal.isSwap && modal.originalItemKey) {
              // Remove original item using line item key
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: modal.originalItemKey, quantity: 0 })
              });
            }
            
            // Dispatch cart refresh event
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } catch(err) {
            console.error(err);
          }
        }
      }
    };
  });
  
  modal.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

async function handleAddClick(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const btn = e.currentTarget;
  const variantId = btn.dataset.variantId;
  const upsellSource = btn.dataset.upsellSource || '';
  
  btn.classList.add('loading');
  const label = btn.querySelector('.label');
  const loader = btn.querySelector('.loading-overlay');
  if (label) label.style.visibility = 'hidden';
  if (loader) loader.classList.remove('hidden');
  
  try {
    const props = { '_upsell_type': 'cart_upsell' };
    if (upsellSource) props['_upsell_source'] = upsellSource;
    
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1, properties: props }] })
    });
    
    location.reload();
  } catch(err) {
    console.error(err);
    btn.classList.remove('loading');
    if (label) label.style.visibility = 'visible';
    if (loader) loader.classList.add('hidden');
  }
}

async function handleVariantClick(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const btn = e.currentTarget;
  const handle = btn.dataset.productHandle;
  
  try {
    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();
    openVariantModal(product, btn.dataset.upsellSource);
  } catch(err) {
    console.error(err);
  }
}

function openVariantModal(product, upsellSource) {
  const modal = document.getElementById('cart-upsell-variant-modal');
  if (!modal) return;
  
  modal.product = product;
  modal.upsellSource = upsellSource;
  modal.selectedOptions = {};
  
  const productEl = modal.querySelector('.cart-upsell-variant-modal__product');
  const optionsEl = modal.querySelector('.cart-upsell-variant-modal__options');
  const addBtn = modal.querySelector('.cart-upsell-variant-modal__add');
  
  productEl.innerHTML = `
    <div class="cart-upsell-variant-modal__product-image">
      <img src="${product.featured_image}" alt="${product.title}">
    </div>
    <div class="cart-upsell-variant-modal__product-info">
      <h3 class="cart-upsell-variant-modal__product-title">${product.title}</h3>
      <div class="cart-upsell-variant-modal__product-price">$${(product.price / 100).toFixed(2)}</div>
    </div>
  `;
  
  let html = '';
  product.options.forEach((opt, idx) => {
    const values = [...new Set(product.variants.map(v => v.options[idx]))];
    html += `<div class="cart-upsell-variant-modal__option-group">
      <span class="cart-upsell-variant-modal__option-label">${opt}</span>
      <div class="cart-upsell-variant-modal__swatches">
        ${values.map(v => `<button type="button" class="cart-upsell-variant-modal__swatch" data-idx="${idx}" data-val="${v}">${v}</button>`).join('')}
      </div>
    </div>`;
  });
  optionsEl.innerHTML = html;
  
  optionsEl.querySelectorAll('.cart-upsell-variant-modal__swatch').forEach(s => {
    s.onclick = () => {
      const idx = parseInt(s.dataset.idx);
      modal.selectedOptions[idx] = s.dataset.val;
      s.closest('.cart-upsell-variant-modal__swatches').querySelectorAll('.cart-upsell-variant-modal__swatch').forEach(x => x.classList.remove('is-selected'));
      s.classList.add('is-selected');
      updateVariantButton(modal);
    };
  });
  
  addBtn.disabled = true;
  addBtn.querySelector('.label').textContent = 'Select Options';
  modal.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function updateVariantButton(modal) {
  const product = modal.product;
  const addBtn = modal.querySelector('.cart-upsell-variant-modal__add');
  
  if (Object.keys(modal.selectedOptions).length === product.options.length) {
    const variant = product.variants.find(v => 
      product.options.every((_, i) => v.options[i] === modal.selectedOptions[i])
    );
    
    if (variant && variant.available) {
      addBtn.disabled = false;
      addBtn.dataset.variantId = variant.id;
      addBtn.querySelector('.label').textContent = `Add ${product.title}`;
    } else {
      addBtn.disabled = true;
      addBtn.querySelector('.label').textContent = 'Unavailable';
    }
  }
}

// Modal event delegation
document.addEventListener('click', (e) => {
  const modal = document.getElementById('cart-upsell-variant-modal');
  if (!modal) return;
  
  if (e.target.closest('.cart-upsell-variant-modal__close') || e.target.closest('.cart-upsell-variant-modal__overlay')) {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  
  const addBtn = e.target.closest('.cart-upsell-variant-modal__add');
  if (addBtn && !addBtn.disabled) {
    const variantId = addBtn.dataset.variantId;
    
    addBtn.classList.add('loading');
    addBtn.querySelector('.label').style.visibility = 'hidden';
    const loader = addBtn.querySelector('.loading-overlay');
    if (loader) loader.classList.remove('hidden');
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        items: [{ 
          id: parseInt(variantId), 
          quantity: 1, 
          properties: { '_upsell_type': 'variant_selected', '_upsell_source': modal.upsellSource || '' }
        }] 
      })
    }).then(() => location.reload());
  }
});

// Initialize event delegation (only needs to run once)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartUpsellButtons);
} else {
  initCartUpsellButtons();
}

